import { FullStory } from '@fullstory/browser';

import { env } from 'env';

const DISABLED_ENVS = ['qa'];

export const isFullStoryEnabled = (): boolean => {
  const appEnv = String(env.REACT_APP_ENV ?? '').toLowerCase();

  return Boolean(appEnv && !DISABLED_ENVS.includes(appEnv));
};

export type FullStoryEventProperties = Record<
  string,
  string | number | boolean
>;

export const trackFullStoryEvent = (
  name: string,
  properties: FullStoryEventProperties
): void => {
  if (!isFullStoryEnabled()) return;

  FullStory('trackEvent', { name, properties });
};
